import React from 'react'
import { VinSearch } from '../../component/VinSearch'

export const VinPage = () => {
  return (
    <VinSearch />
  )
}
